<template>
  <div>
    <van-dialog v-model="batchRefundVisible" title="批量退款给客户" width="95%" style="height:80%" class="editClue" >
      <van-form ref="batchRefundForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">退款给客户信息</van-divider>
        <div class="card" style="padding: 5px;min-height: 10px;margin-bottom: 0">
          <div class="list-wrap van-hairline--top" style="padding-top: 0;">
            <div class="item" style="margin-bottom: 0; padding-left:105px;text-indent:-105px;">
              <span class="key">充值剩余金额：</span>
              <span class="value" style="color: #ee0a24;">
                ￥{{batchRefundForm.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(batchRefundForm.rechargeRemainMoney)}}</span>
              </span>
            </div>
            <van-cell title="是否退充值剩余金额：" required style="margin-left: -10px;">
              <template>
                <van-radio-group v-model="batchRefundForm.isRecharge" direction="horizontal" @change="isRechargeRadio">
                  <van-radio :name="1" clickable>否</van-radio>
                  <van-radio :name="2" clickable>是</van-radio>
                </van-radio-group>
              </template>
            </van-cell>
          </div>
          <van-list>
            <van-cell v-for="(item,index) in batchRefundList" :key="index" style="background-color: #e4e4e4;">
              <div class="flex-between" v-if="item" style="align-items: flex-start">
                <div class="contract_detail">
                  <div class="item" style="padding-left:70px;text-indent:-70px;">
                    <span class="key">项目名称：</span>
                    <span class="value">{{ item.projectName }}</span>
                  </div>
                  <div class="item">
                    <span class="key">所属服务商ID：</span>
                    <span class="value">{{ item.serviceId }}</span>
                  </div>
                  <div class="item">
                    <span class="key">账户ID：</span>
                    <span class="value">{{ item.accountNo }}</span>
                  </div>
                  <div class="item">
                    <span class="key">充值账户币：</span>
                    <span class="value">{{ item.rechargeMoney }}</span>
                    <span class="key" style="margin-left: 20px;">充值现金金额：</span>
                    <span class="value">{{ item.payMoney }}</span>
                  </div>
                  <div class="item">
                    <span class="key">退款账户币：</span>
                    <span class="value">{{ item.refundRechargeMoney }}</span>
                    <span class="key" style="margin-left: 20px;">退款现金金额：</span>
                    <span class="value">{{ item.refundPayMoney }}</span>
                  </div>
                  <div class="item">
                    <span class="key">账户返点：</span>
                    <span class="value">{{ item.percentage }}%</span>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
          <!-- <div class="list-wrap van-hairline--top" style="padding-top: 0; margin-top: 10px;">
            <div class="item" style="margin-bottom: 0; padding-left:90px;text-indent:-90px;">
              <span class="key">退款总金额：</span>
              <span class="value" style="color: #ee0a24;">
                ￥{{batchRefundForm.refundMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(batchRefundForm.refundMoney)}}</span>
              </span>
            </div>
          </div> -->
          <van-field v-model="batchRefundForm.refundMoney" label="退款总金额" placeholder="请输入退款总金额(元)" type="number" :disabled="batchRefundForm.isRecharge == 1" :rules="[{ required: true }]" required />
        </div>
        <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold', marginTop: '0', marginBottom: '0' }">退款信息</van-divider>

        <van-field v-model="batchRefundForm.custName" label="退款信息" placeholder="请输入退款信息" type="textarea" rows="3" :rules="[{ required: true }]" required />
        <!-- <van-field v-model="batchRefundForm.custName" label="退款单位名称" placeholder="请输入退款单位名称" :rules="[{ required: true }]" required disabled />
        <van-field v-model="batchRefundForm.bankName" label="开户行" placeholder="请输入开户行" :rules="[{ required: true }]" required />
        <van-field v-model="batchRefundForm.bankNo" label="退款账号" placeholder="请输入退款账号" :rules="[{ required: true }]" required /> -->
        <van-field v-model="batchRefundForm.refundReason" label="退款内容说明" placeholder="请输入退款内容说明" type="textarea" rows="3" :rules="[{ required: true }]" required />
        <van-field v-model="batchRefundForm.refundUrl" label="退款函" placeholder="请点击下方上传退款函" :rules="[{ required: true }]" required readonly />
        <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
        <div style="color: #ff976a; font-size: 14px;">只能上传一张jpg/png格式图片，且不超过10mb</div>
      </van-form>
      <div class="footer">
        <van-button hairline type="defaut" plain @click="batchRefundVisible = false">取消</van-button>
        <van-button hairline type="primary" plain @click="saveBatchRefund">确认</van-button>
      </div>
    </van-dialog>
    <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>
    <!-- <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup> -->
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
import { Toast, Dialog, ImagePreview } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {

      batchRefundVisible: false,
      batchRefundList: [],
      batchRefundForm: {
        idList: [],
        isRecharge: 1,
        rechargeRemainMoney: null,
        advancesRechargeId: null,
        refundMoney: null,
        custName: null,
        bankName: null,
        bankNo: null,
        refundUrl: null,
        refundReason: null
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      imageShow: false,
      imageArr: [],
      pictureList: []

    }
  },
  async mounted() {

  },
  methods: {
    // 详情
    async handleBatchRefund(row) {
      row.refundMoney = null
      row.isRecharge = 1
      this.batchRefundForm = row
      // this.batchRefundForm.isRecharge = 1
      this.batchRefundForm.advancesRechargeId = row.batchRefundList[0].contNewIncomeDetailExecId
      this.batchRefundForm.idList = row.batchRefundList.map(item => item.contNewIncomeDetailExecAccountId)
      this.batchRefundForm.refundMoney = row.batchRefundList.reduce((total, item) => total + Number(item.payMoney), 0)
      this.batchRefundForm.custName = null
      this.batchRefundList = row.batchRefundList
      this.batchRefundVisible = true
    },
    isRechargeRadio(val) {
      if (val === 1) {
        this.batchRefundForm.refundMoney = this.batchRefundList.reduce((total, item) => total + Number(item.payMoney), 0)
      } else if (val === 2) {
        this.batchRefundForm.refundMoney = this.batchRefundForm.rechargeRemainMoney
      }
      this.$forceUpdate()
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.batchRefundForm.refundUrl = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    handleRemove(file) {
      this.batchRefundForm.refundUrl = ''
      this.pictureList = []
      return true
    },
    async saveBatchRefund() {
      await this.$refs.batchRefundForm.validate()
      await channel.batchRefund(this.batchRefundForm).then(response => {
        if (response.code === 200) {
          Toast.success(response.msg)
          this.batchRefundVisible = false
          this.batchRefundForm = {
            idList: [],
            isRecharge: 1,
            rechargeRemainMoney: null,
            advancesRechargeId: null,
            refundMoney: null,
            custName: null,
            bankName: null,
            bankNo: null,
            refundUrl: null,
            refundReason: null
          }
          this.pictureList = []
          this.$parent.getRechargeList()
        } else {
          Toast.fail(response.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

.editClue /deep/.van-dialog__content {
  height: 82%;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 50%;
    border: 1px #f4f4f4 solid;
  }
}
// .van-cell__value {
//   min-width: 47%; // 可根据自己需求设定值
//   text-align: left;
// }
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}
</style>
